const HeaderMockInquiriesWarning = () => {
  return (
    <div
      style={{
        backgroundColor: 'red',
        color: 'white',
        padding: '6px 4px 2px 4px',
        borderRadius: '5px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '12px',
        position: 'absolute',
        top: '-4px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '1000',
        width: '200px',
      }}
    >
      Mock Inquires Enabled
    </div>
  );
};

export default HeaderMockInquiriesWarning;
